module.exports = __webpack_public_path__ + "img/clic.1c06fb88.gif";